import React from "react";

function Logo({ src, alt, color, style, index, ...rest }) {
  const borderRadius =
    color?.elements?.shape === "Pill"
      ? "16px"
      : color?.elements?.shape === "Rounded"
      ? "16px"
      : "0px";

  return (
    <div key={index}>
      <img
        style={{
          borderRadius: borderRadius,
          width: "100%",
          height: "auto",
          objectFit: "cover",
          marginTop: "8px",
        }}
        src={src}
        alt={"/logo"}
      />
    </div>
  );
}

export default Logo;
